export default function AnimatedHeroWave() {
  return (
    <svg
      className="hero-wave"
      viewBox="0 0 1600 180"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="heroWaveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#009A97" stopOpacity="0" />
          <stop offset="45%" stopColor="#22C1A6" stopOpacity="0.35" />
          <stop offset="65%" stopColor="#4D7CFE" stopOpacity="0.22" />
          <stop offset="100%" stopColor="#009A97" stopOpacity="0" />
        </linearGradient>
      </defs>
      {[0, 15, 30, 45, 60].map((offset) => (
        <path
          key={offset}
          d={`M-80 ${105 + offset / 3}
              C 250 ${20 + offset},
                500 ${175 - offset},
                810 ${85 + offset / 2}
              S 1310 ${30 + offset},
                1680 ${100 + offset / 4}`}
          fill="none"
          stroke="url(#heroWaveGradient)"
          strokeWidth="1"
        />
      ))}
    </svg>
  );
}